import React from "react";
import PropTypes from "prop-types";
import _Switch from "../../../../components/generic/_Switch";
const StepTwo = ({ data, selectedHeaders, setSelectedHeaders }) => {
  const _onToogle = (item) => {
    let idx = selectedHeaders.indexOf(item);
    if (idx !== -1) {
      selectedHeaders.splice(idx, 1);
    } else {
      selectedHeaders.push(item);
    }
    setSelectedHeaders([...selectedHeaders]);
  };

  return (
    <div>
      <div>
        <div className="text-sm font-semibold text-gray-600">
          Selecciona los campos a ignorar
        </div>
        <div className="flex flex-col w-full">
          {data.map((item) => {
            return (
              <div
                key={item}
                className="flex justify-between items-center w-full border rounded-lg px-2 py-1 m-[2px]"
              >
                <div className="ml-2">{item}</div>
                <_Switch
                  checked={selectedHeaders.indexOf(item) !== -1}
                  onChange={() => _onToogle(item)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

StepTwo.propTypes = {
  data: PropTypes.array,
  selectedHeaders: PropTypes.array,
  setSelectedHeaders: PropTypes.func,
};

export default StepTwo;
